// Vertical carousel with click-to-zoom, keyboard navigation, and synced panels.
(function () {
  const WHEEL_THRESHOLD = 100;

  // --- Elements ---

  const pdpNav = document.querySelector(".pdp-nav");
  const pdpNavNotify = pdpNav.querySelector(".pdp-nav__button--notify");

  const carousel = document.querySelector(".pdp-carousel--desktop");
  if (!carousel) return;

  const wrapper = carousel.querySelector(".pdp-carousel__inner");
  const track = carousel.querySelector(".pdp-carousel__track");
  if (!track || !wrapper) return;

  const nav = carousel.querySelector(".pdp-content__nav");
  const links = carousel.querySelectorAll(".pdp-content__nav-link");
  const slides = Array.from(track.querySelectorAll(".pdp-carousel__slide"));
  if (slides.length === 0) return;

  const slideCount = slides.length;
  const detailsInner = document.querySelector(".pdp-content__details__inner");
  const detailsTrack = detailsInner?.querySelector(
    ".pdp-content__details__track",
  );
  const detailsSections = detailsTrack?.querySelectorAll(
    ".pdp-content__details__section",
  );
  const sectionCount = detailsSections.length;

  // --- Equalize slide and section counts ---

  const maxItems = Math.max(slideCount, sectionCount);

  for (let i = slideCount; i < maxItems; i++) {
    const el = document.createElement("div");
    el.className = "pdp-carousel__slide";
    el.setAttribute("role", "listitem");
    el.setAttribute("aria-hidden", "true");
    track.appendChild(el);
  }

  for (let i = sectionCount; i < maxItems; i++) {
    const el = document.createElement("section");
    el.className = "pdp-content__details__section";
    el.setAttribute("aria-hidden", "true");
    detailsTrack?.appendChild(el);
  }

  const allSlides = Array.from(track.querySelectorAll(".pdp-carousel__slide"));
  const allSections = detailsTrack
    ? Array.from(
        detailsTrack.querySelectorAll(".pdp-content__details__section"),
      )
    : [];

  // --- State ---

  let slideHeight = 0;
  let currentIndex = 0;
  let zoomedSlide = null;
  let transitioning = false;
  let wheelDelta = 0;

  // --- Navigation ---

  function updateSections() {
    allSections.forEach((section, i) => {
      section.classList.toggle("is-active", i === currentIndex);
      section.classList.toggle("is-above", i < currentIndex);
      section.classList.toggle("is-below", i > currentIndex);
    });

    nav.classList.toggle("inverted", currentIndex === 0);
    pdpNav.classList.toggle("active", currentIndex !== 0);
  }

  function goToSlide(idx) {
    const clamped = Math.min(maxItems - 1, Math.max(0, idx));
    if (clamped === currentIndex) return;

    currentIndex = clamped;
    track.style.transform = `translateY(-${currentIndex * slideHeight}px)`;

    links.forEach((link, i) => {
      link.classList.toggle("active", i === currentIndex);
    });

    updateSections();
    transitioning = true;
  }

  function measure() {
    if (zoomedSlide) {
      zoomOut();
    }

    slideHeight = wrapper.offsetHeight;
    allSlides.forEach((s) => {
      s.style.height = `${slideHeight}px`;
    });

    track.style.transition = "none";
    track.style.transform = `translateY(-${currentIndex * slideHeight}px)`;

    requestAnimationFrame(() => {
      track.style.transition = "";
    });

    links.forEach((link, i) => {
      link.classList.toggle("active", i === currentIndex);
    });

    updateSections();
  }

  function isFullyVisible() {
    const rect = carousel.getBoundingClientRect();
    return rect.top >= -1 && rect.bottom <= window.innerHeight + 1;
  }

  // --- Zoom ---

  function updateZoomOrigin(slide, e) {
    const rect = slide.getBoundingClientRect();
    const pct = (val, size) => Math.max(0, Math.min(100, (val / size) * 100));
    slide.style.setProperty(
      "--zoom-x",
      `${pct(e.clientX - rect.left, rect.width)}%`,
    );
    slide.style.setProperty(
      "--zoom-y",
      `${pct(e.clientY - rect.top, rect.height)}%`,
    );
  }

  function zoomIn(slide, e) {
    zoomedSlide = slide;
    updateZoomOrigin(slide, e);
    slide.classList.add("is-zoomed");
    carousel.classList.add("is-zoomed");
  }

  function zoomOut() {
    if (!zoomedSlide) return;
    zoomedSlide.classList.remove("is-zoomed");
    carousel.classList.remove("is-zoomed");
    zoomedSlide = null;
  }

  // --- Event handlers ---

  function onClick(e) {
    const slide = e.target.closest(".pdp-carousel__slide");
    if (!slide) return;

    if (zoomedSlide) {
      zoomOut();
      return;
    }

    zoomIn(slide, e);
  }

  function onMouseMove(e) {
    if (!zoomedSlide) return;
    updateZoomOrigin(zoomedSlide, e);
  }

  function onWheel(e) {
    if (!isFullyVisible()) return;

    if (transitioning || zoomedSlide) {
      e.preventDefault();
      return;
    }

    const atStart = currentIndex === 0 && e.deltaY < 0;
    const atEnd = currentIndex === maxItems - 1 && e.deltaY > 0;

    if (atStart || atEnd) {
      wheelDelta = 0;
      return;
    }

    e.preventDefault();
    wheelDelta += e.deltaY;

    if (Math.abs(wheelDelta) < WHEEL_THRESHOLD) return;

    if (wheelDelta > 0) {
      goToSlide(currentIndex + 1);
    } else {
      goToSlide(currentIndex - 1);
    }

    wheelDelta = 0;
  }

  function onKeydown(e) {
    if (document.activeElement !== wrapper) return;

    if (zoomedSlide) {
      if (e.key === "Escape") {
        zoomOut();
        e.preventDefault();
      }
      return;
    }

    if (transitioning) return;

    const targets = {
      ArrowUp: currentIndex - 1,
      ArrowDown: currentIndex + 1,
      Home: 0,
      End: maxItems - 1,
    };

    if (!(e.key in targets)) return;

    goToSlide(targets[e.key]);
    e.preventDefault();
  }

  function onNotifyClick(e) {
    e.preventDefault();
    e.stopPropagation();

    const buyBoxNotify = carousel.querySelector(".buy-box__notify");
    if (!buyBoxNotify) return;

    goToSlide(0);
    buyBoxNotify.classList.add("visible");

    const buyBoxEmailInput = buyBoxNotify.querySelector(".email-form__input");
    if (buyBoxEmailInput) {
      setTimeout(() => buyBoxEmailInput.focus(), 500);
    }
  }

  // --- Init ---

  track.addEventListener("transitionend", (e) => {
    if (e.target === track && e.propertyName === "transform") {
      transitioning = false;
    }
  });

  links.forEach((link, i) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      goToSlide(i);
    });
  });

  wrapper.addEventListener("wheel", onWheel, { passive: false });
  if (detailsInner) {
    detailsInner.addEventListener("wheel", onWheel, { passive: false });
  }

  if (pdpNavNotify) {
    pdpNavNotify.addEventListener("click", onNotifyClick);
  }

  window.addEventListener("mousemove", onMouseMove);
  wrapper.addEventListener("click", onClick);
  wrapper.addEventListener("keydown", onKeydown);
  window.addEventListener("resize", measure);

  measure();

  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href="#provenance-proof-points"]');
    if (!link || !carousel.contains(link)) return;

    if (link.closest('.provenance-snippet')) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const provenanceItem = carousel.querySelector(
      ".accordion__item[data-provenance]",
    );
    if (!provenanceItem) return;

    const section = provenanceItem.closest(
      ".pdp-content__details__section",
    );
    const sectionIndex = section
      ? allSections.indexOf(section)
      : -1;

    if (sectionIndex >= 0) {
      goToSlide(sectionIndex);
    }

    if (!provenanceItem.classList.contains("accordion__item--expanded")) {
      const trigger = provenanceItem.querySelector(".accordion__trigger");
      if (trigger) trigger.click();
    }
  }, true);

  requestAnimationFrame(() => {
    detailsTrack?.classList.add("is-ready");
  });
})();
